// import Swiper JS
import Swiper from 'swiper/bundle';
import 'core-js/features/number';
import 'core-js/features/string/repeat';

const $ = jQuery;

document.querySelectorAll('.swiper-container.image-gallery__swiper').forEach((el) => {
  const nextEl = el.querySelector('.swiper-button-next');
  const prevEl = el.querySelector('.swiper-button-prev');

  const swiper = new Swiper(el, {
    effect: "slide",
    spaceBetween: 10,
    slideToClickedSlide: true,
    loop: false,
    navigation: {
      nextEl,
      prevEl,
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 10 },
      641: { slidesPerView: 1.3, spaceBetween: 10 },
    },
  });

  const bigEl = document.querySelector(".image-gallery__swiper--full");
  const bigNext = bigEl.querySelector(".swiper-button-next--big");
  const bigPrev = bigEl.querySelector(".swiper-button-prev--big");

  const swiperBig = new Swiper(bigEl, {
    effect: "slide",
    lazy: true,
    spaceBetween: 10,
    loop: false,
    slideToClickedSlide: true,
    controller: {
    control: swiper
  },
    thumbs: { swiper },
    navigation: {
      nextEl: bigNext,
      prevEl: bigPrev,
    },
  });

  $('.image-gallery-widget__content .swiper-slide').on('click', () => {
    $('.image-gallery__popup').addClass('open');

    // Sync slides.
    requestAnimationFrame(() => {
      swiperBig.update();
      swiperBig.slideTo(swiper.activeIndex, 0);
      swiperBig.lazy.load();
    });
  });

});

$('#close-gallery').click(() => {
  $('.image-gallery__popup').removeClass('open');
});

